import React from 'react';

import '../style.css';

export default class ShareButton extends React.Component {
  constructor(props) {
    super(props);
    this.state = Object.assign(
      {
        shared: false,
      },
      props
    );
  }

  render() {
    return (
      //   <button
      //     className='Share'
      //     onClick={() =>
      //       this.setState(function (state) {
      //         return {
      //           shared: !state.shared,
      //         };
      //       })
      //     }>
      //     <ArrowSweptToRightFromBottomIcon
      //       fill={this.state.shared ? 'var(--black)' : 'transparent'}
      //       stroke={this.state.shared ? 'var(--black)' : 'var(--cool-grey)'}
      //     />
      //   </button>
      null
    );
  }
}
